/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type AbsenceReason = typeof AbsenceReason[keyof typeof AbsenceReason];


export const AbsenceReason = {
  ANNUALLEAVE: 'ANNUALLEAVE',
  SICKNESS: 'SICKNESS',
  OTHERABSENCES: 'OTHERABSENCES',
} as const;
